import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
// Обе ветки каждой карты — литеральные строки, чтобы сканер Tailwind их нашёл.
const toneStripe = {
    neutral: 'border-l-[var(--color-state-neutral-solid)]',
    brand: 'border-l-[var(--color-brand-bg)]',
    success: 'border-l-[var(--color-state-success-solid)]',
    warning: 'border-l-[var(--color-state-warning-solid)]',
    danger: 'border-l-[var(--color-state-danger-solid)]',
    info: 'border-l-[var(--color-state-info-solid)]',
};
const toneChip = {
    neutral: 'bg-[var(--color-surface-sunken)] text-[var(--color-text-secondary)]',
    brand: 'bg-[var(--color-brand-bg)] text-[var(--color-brand-fg)]',
    success: 'bg-[var(--color-state-success-bg)] text-[var(--color-state-success-fg)]',
    warning: 'bg-[var(--color-state-warning-bg)] text-[var(--color-state-warning-fg)]',
    danger: 'bg-[var(--color-state-danger-bg)] text-[var(--color-state-danger-fg)]',
    info: 'bg-[var(--color-state-info-bg)] text-[var(--color-state-info-fg)]',
};
const valueClasses = {
    // Deliberately NOT `tabular-nums`: equal-width digits make a large standalone
    // number look loose. Tabular figures are for columns that align vertically.
    md: 'text-2xl font-semibold leading-tight',
    hero: 'text-5xl font-semibold leading-none tracking-tight',
};
/**
 * `label` · `value` · optional `footer`. The whole contract of a stat tile:
 * a number and what it is. An explanatory paragraph does not live in the tile
 * body — it goes behind `hint`.
 */
export const StatTile = React.forwardRef(({ label, value, hint, footer, size = 'md', className, labelClassName, tone, accentToken, icon: Icon, style, ...props }, ref) => {
    const accented = tone !== undefined || accentToken !== undefined;
    return (_jsxs("div", { ref: ref, "data-tone": accentToken ? 'custom' : tone, className: cn('flex min-w-0 flex-col gap-1', accented && 'border-l-4 pl-3', accented && !accentToken && toneStripe[tone ?? 'neutral'], className), 
        // Токен задан именем переменной — Tailwind не может перечислить их
        // заранее, поэтому полоса красится inline (как ChannelBadge).
        style: accentToken ? { borderLeftColor: `var(${accentToken})`, ...style } : style, ...props, children: [_jsxs("span", { className: cn('flex items-center gap-1 text-xs leading-snug font-medium text-[var(--color-text-muted)]', labelClassName), children: [Icon ? (_jsx("span", { "aria-hidden": true, className: cn('mr-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-[var(--radius-2)]', toneChip[tone ?? 'neutral']), children: _jsx(Icon, { className: "h-3.5 w-3.5" }) })) : null, _jsx("span", { className: "min-w-0", children: label }), hint] }), _jsx("span", { className: cn(valueClasses[size], 'text-[var(--color-text-primary)]'), children: value }), footer != null ? _jsx("div", { className: "mt-0.5 text-xs", children: footer }) : null] }));
});
StatTile.displayName = 'StatTile';
//# sourceMappingURL=stat-tile.js.map